module.exports = __webpack_public_path__ + "static/media/location_primary.0aff5414.svg";